import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorUpTrend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M5 21.75A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5ZM3.75 19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v14Z"
    />
    <path
      fill="#F7A600"
      d="M18.104 8.454c.383.108.606.515.504.918l-.881 3.457c-.105.41-.508.662-.9.563-.393-.1-.627-.513-.523-.923l.444-1.74-4.114 3.097a.75.75 0 0 1-.994-.082l-1.017-1.07-4.706 3.15a.75.75 0 0 1-.834-1.247l5.23-3.5a.75.75 0 0 1 .961.106l.992 1.043 3.697-2.783-1.561-.44c-.39-.11-.614-.53-.5-.937.115-.407.524-.648.914-.538l3.287.926Z"
    />
  </svg>
);
export default SvgTwoColorUpTrend;
